export enum OnyxScheduleCompliance {
  ON_TIME = 'onTime',
  DELAY_RISK = 'delayRisk',
  DELAYED = 'delayed',
}

export const getScheduleComplianceRank = (
  compliance: OnyxScheduleCompliance,
): number =>
  (
    ({
      [OnyxScheduleCompliance.ON_TIME]: 0,
      [OnyxScheduleCompliance.DELAY_RISK]: 1,
      [OnyxScheduleCompliance.DELAYED]: 2,
    }) as const
  )[compliance];
